import {UBLinkPath, useUdemyBusinessLink} from '@udemy-v2/organization-growth';
import {useClpCourse} from '@/features/course-landing-page/context/clp-course-provider.react-component';

interface UBCtaParams {
    ubHref: string;
    eventData: Record<string, string>;
}

export enum CtaPlacement {
    NON_PP_TRANSACTION = 'non-pp-transaction',
    DEFAULT = 'default',
}

export const useUbCtaParams = ({
    ctaPlacement = CtaPlacement.DEFAULT,
}: {ctaPlacement?: CtaPlacement} = {}): UBCtaParams => {
    const course = useClpCourse();
    const primaryCategory = course?.categories?.[0];
    const eventData = {
        utm_source: 'marketplace',
        utm_medium: 'referral',
        utm_campaign: 'mx-hooks',
        utm_content: 'clp',
    };
    const ubParams = {
        ref: `marketplace_${primaryCategory?.name ?? ''}`,
        ...(ctaPlacement === CtaPlacement.NON_PP_TRANSACTION ? eventData : {}),
    };

    // In the monolith, we encrypt the user ID and pass it as a query param to the link
    // TODO: Determine if we need to implement this logic as well
    //        if self.request.user.is_authenticated:
    //             ufb_params["data_h"] = django_style.encrypt(self.request.user.id)

    const ubHref = useUdemyBusinessLink(UBLinkPath.REQUEST_DEMO_MX, ubParams);

    return {ubHref, eventData};
};
